import React from 'react';
import logo from '../../assets/footer_logo.png';
import './Footer.scss';
import { FaFacebookF, FaInstagram, FaTwitter} from "react-icons/fa";
import { Link } from 'react-router-dom';
import call from '../../assets/footer/calling.png';
import time from '../../assets/footer/time.png';
import location from '../../assets/footer/location.png';

const Footer = () => {

    const footerMenu = [
        {
            'name' : 'About Us',
            'link' : '/about',
        },
        {
            'name' : 'Dental Plans',
            'link' : '/singleservice',
        },
        {
            'name' : 'Dr. Vinamrata',
            'link' : '/about#expert',
        },
        {
            'name' : 'Contact Us',
            'link' : 'tel:6395947006',
        },
        {
            'name' : 'Location',
            'link' : '/#map',
        }
    ];

    const footerContacts = [
        {
            'title': 'Phone Number',
            'info': '6395947006',
            'icon': call
        },
        {
            'title': 'Walk-in Hours',
            'info': '10:00 AM - 1:30 PM | 5:30 PM - 7:30 PM',
            'icon': time
        },
        {
            'title': 'Clinic Address',
            'info': 'Shop No. 6, Sharma Garden, Near Mahindra Petrol Pump, Yamunanagar – 135001 (HR)',
            'icon': location
        }
    ]

    return (
        <footer className='pt-100 pb-70'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-5">
                        <div className="footer-logo">
                            <img src={logo} alt="logo" />
                        </div>
                        <p>TRUECARE DENTAL & IMPLANT CENTER is a premier dental practice in Yamunanagar, offering comprehensive dental care with expert MDS specialists and modern equipment.</p>

                        <div className="social-logo">
                            <p>Follow us on</p>
                            <ul>
                                <li><a href="/"><FaFacebookF/></a></li>
                                <li><a href="/"><FaTwitter/></a></li>
                                <li><a href="/"><FaInstagram/></a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-2">
                        <div className="footer-link">
                            <p>Quick Links</p>
                            <ul>
                                {
                                    footerMenu.map(singleMenu => 
                                        <li>
                                            {singleMenu.link.startsWith('tel:') ? (
                                                <a href={singleMenu.link}>{singleMenu.name}</a>
                                            ) : (
                                                <Link to={singleMenu.link}>{singleMenu.name}</Link>
                                            )}
                                        </li>
                                    )
                                }
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-5">
                        <div className="footer-contact">
                            <p>Contact & Information</p>

                            {
                                footerContacts.map(footerContact => {
                                    return  <div className="contact-list">
                                                <div className="contact-icon">
                                                    <img src={footerContact.icon} alt="call" />
                                                </div>
                                                <div className="contact-text">
                                                    <p>{footerContact.title}</p>
                                                    <h5>{footerContact.info}</h5>
                                                </div>
                                            </div>
                                })
                            }
                        </div>
                    </div>
                </div>

                <div className="copyright-area">
                    <div className='copy-text'>
                        <p>&copy; TRUECARE DENTAL & IMPLANT CENTER. All Rights Reserved</p>
                    </div>  
                    <div className='copy-links'>
                        <ul>
                            <li><Link to='/'>Terms of Use</Link></li>
                            <li><Link to='/'>Privacy Policy</Link></li>
                        </ul>
                    </div>                          
                </div>
            </div>
        </footer>
    );
};

export default Footer;